import TraceTile from '@/creditflowresearch/ui/components/trace/TraceTile';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useModuleVisibility } from '@/creditflowresearch/application/ModuleVisibility';
import { TRACE_TILE_HEADER_MAPPING_NAME } from '@/creditflowresearch/application/Bonds/constants';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import {
  getUnauthorizedDescription,
  getProDescription,
} from '@/creditflowresearch/ui/common/components/organisms/constants';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import { ITraceTileProps } from '@/creditflowresearch/ui/components/trace/TraceTile/TraceTile';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';

import styles from './traceTile.module.scss';

const tooltipContent = 'Analyze secondary market liquidity with timely and valuable trading data from '
                       + 'TRACE by FINRA.';

interface ITraceTileWithFallbackProps extends ITraceTileProps {
  userAccessChecks: boolean[],
}

const TraceTileWithFallback = ({
  userAccessChecks,
  ...otherProps
}: ITraceTileWithFallbackProps) => {
  const { checkAccessByUserPlan, plan } = useUserPlanContext();
  const isModuleVisible = useModuleVisibility(TRACE_TILE_HEADER_MAPPING_NAME);

  if (!isModuleVisible) return null;

  const checks = [
    ...userAccessChecks,
    checkAccessByUserPlan(UserPlanType.PRO),
  ];
  const baseProps = {
    title: 'TRACE',
    dataTest: 'traceTile',
    tooltipContent,
    className: styles.fallbackContainer,
  };
  const traceUrl = cfrUrl.getTraceUrl();

  return (
    <CheckUserAccess
      conditions={ [
        {
          checks: [!UserPlan.isUnauthorized(plan)],
          fallback: (
            <TileAccessFallback
              { ...baseProps }
              description={ (
                <div className={ styles.unAuthDescription }>
                  { getUnauthorizedDescription(traceUrl) }
                </div>
              ) }
              actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
            />
          ),
        },
        {
          checks,
          fallback: (
            <TileAccessFallback
              { ...baseProps }
              description={ (
                <div className={ styles.authDescription }>
                  { getProDescription(traceUrl) }
                </div>
              ) }
            />
          ),
        },
      ] }
    >
      <TraceTile { ...otherProps } />
    </CheckUserAccess>
  );
};

export default TraceTileWithFallback;
